import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "waiting-rooms w-full" }
const _hoisted_2 = { class: "h6 mbottom-04 flex justify-start align-center flex-row" }
const _hoisted_3 = { class: "room-occupants" }
const _hoisted_4 = {
  key: 0,
  class: "flex-col"
}
const _hoisted_5 = { class: "mbottom-10" }
const _hoisted_6 = { class: "row w-full mt-2" }
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "row mtop-10 w-full mbottom-10"
}
const _hoisted_10 = { class: "col-0-12 colend mright-04" }
const _hoisted_11 = { class: "main-m font-m" }
const _hoisted_12 = { class: "col-1-5 w-full font-m" }
const _hoisted_13 = { class: "mt-2 flex justify-end" }

import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import EsDataCard from '@/components/esDataCard.vue';
import {useWaitingRoomsStore} from '@/stores/waitingRooms';
import { useAppUserStore } from '@/stores/appUser';
import EsWaitingRoomSelector from '@/components/EsWaitingRoomSelector.vue';
import esWaitingRoomBadge from '@/components/esWaitingRoomBadge.vue';
import {AppointmentApi, LightAppointment, PatientLightResponse, UpdateAppointmentLocation} from '@/apiGenerate/medserver';
import {medServerApiConfig} from '@/config/medserver-api.config';
import { ApiError, PatientStatus } from '@/models/share.model';
import { useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import SharedService from '@/services/SharedService';
import SelectButton from 'primevue/selectbutton';
import Popover from 'primevue/popover';
import { formatUTCDateTimeToTime } from '@/utils/date-utils';
import useRefetch from '@/functions/useRefetch';
import PersonService from '@/services/PersonService';


export default /*@__PURE__*/_defineComponent({
  __name: 'esPlanningWaitingRooms',
  emits: ['refreshCalendar'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const waitingRoomsStore = useWaitingRoomsStore();
const appUserStore = useAppUserStore();

const emits = __emit;

const appointmentApi = new AppointmentApi(medServerApiConfig);
const toast = useToast();
const selectedPatient = ref<PatientLightResponse>(null);
const selectedAppointmentId = ref<string | null>(null);
const selectedRoom = ref<any>(null);
const currentAppointment = ref<LightAppointment>(null);

const changeWaittingRoomForm = ref<UpdateAppointmentLocation>({
  roomId: undefined,
  customRoomName: undefined
});

const currentAppointmentId = ref<string>(undefined);
const patientPopoverRef = ref<InstanceType<typeof Popover> | null>(null);

const patientStatus = ref([
    {
      optionValue: PatientStatus.WAITING,
      optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
      icon: 'hourglass_2_fill',
      index: 0
    },
    {
      optionValue: PatientStatus.OUT,
      optionLabel: t('common.patientStatus.' + PatientStatus.OUT),
      icon: 'empty-set',
      index: 1
    },
    {
      optionValue: PatientStatus.LEAVE,
      optionLabel: t('common.patientStatus.' + PatientStatus.LEAVE),
      icon: 'checkmark-square',
      index: 2
    }
  ]);
const currentPatientStatus = ref({
      optionValue: PatientStatus.WAITING,
      optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
      icon: 'hourglass_2_fill',
      index: 0
    });

async function updateAppointmentLocation(appointmentId: string, location: UpdateAppointmentLocation) {
  currentAppointmentId.value = appointmentId;
  changeWaittingRoomForm.value = location;
}

const finishAppointment = async(patientStatus: any, appointmentId: string) => {
  if (
    currentPatientStatus.value?.optionValue !== patientStatus?.optionValue
  ) {
    currentPatientStatus.value = patientStatus;
    currentAppointmentId.value = appointmentId;
    if (currentPatientStatus.value.optionValue === PatientStatus.OUT) {
      changeWaittingRoomForm.value = undefined;
      selectedRoom.value = undefined;
    }
  }
}

const executeFinishAppointment = async() => {
 appointmentApi.finishAppointment({appointmentId: currentAppointmentId.value}).then(() => {
    toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail:  t('calendar.label.message.success.update')
    });
    waitingRoomsStore.updateWaitingRooms();
    currentPatientStatus.value = {
      optionValue: PatientStatus.WAITING,
      optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
      icon: 'hourglass_2_fill',
      index: 0
    };
    emits('refreshCalendar');
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
  })
} 

const confirmFormModal = async () => {
  if (changeWaittingRoomForm.value) {
    await appointmentApi.setAppointmentLocation({
      appointmentId: currentAppointmentId.value,
      updateAppointmentLocation: {
        roomId: changeWaittingRoomForm.value.roomId,
      customRoomName: changeWaittingRoomForm.value.customRoomName
      }
    }).then(() => {
      if (currentPatientStatus.value.optionValue === PatientStatus.LEAVE) {
        executeFinishAppointment()
      } else {
        toastSuccess(toast, {
          summary: t('common.toast.success.update'),
          detail:  t('calendar.label.message.success.update')
        });
        waitingRoomsStore.updateWaitingRooms();
        emits('refreshCalendar');
      }
      selectedPatient.value = null;
      selectedAppointmentId.value = null;
      patientPopoverRef.value?.hide();
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
    });
  } else if (currentPatientStatus.value.optionValue === PatientStatus.LEAVE) {
    executeFinishAppointment();
    emits('refreshCalendar');
  }
}

const openPatientModal = async (patient: PatientLightResponse, appointmentId: string, room: any, event: any) => {
  selectedPatient.value = patient;
  selectedAppointmentId.value = appointmentId;
  selectedRoom.value = room;

  if (selectedRoom.value) {
    currentPatientStatus.value = {
      optionValue: PatientStatus.WAITING,
      optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
      icon: 'hourglass_2_fill',
      index: 0
    };
  }

  getAppointment();
  patientPopoverRef.value?.show(event);
};

const confirmCancelFormModal = () => {
  if(currentPatientStatus.value.optionValue === PatientStatus.LEAVE){
    currentPatientStatus.value = patientStatus.value.find(item => item.optionValue === PatientStatus.WAITING);
  }
  patientPopoverRef.value?.hide();
  selectedPatient.value = null;
  selectedAppointmentId.value = null;
};

const getAppointment = async () => {
  await appointmentApi.getAppointment({appointmentUuid: selectedAppointmentId.value}).then((response: LightAppointment) => {
    currentAppointment.value = response;
  }).catch((error: ApiError) => {
      toastError(toast, {
          summary: t('common.toast.error'),
          detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
  });
}

useRefetch(
  () => waitingRoomsStore.updateWaitingRooms(),
  waitingRoomsStore.updateWaitingRoomsFrequency * 1000
);

watch(
  () => appUserStore.refreshCalendar,
  async () => {
    if (appUserStore.refreshCalendar) {
      await waitingRoomsStore.updateWaitingRooms();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_text_item, {
      txt: _unref(t)('calendar.waiting.title'),
      styles: "font-lBold",
      class: "mleft-08 mtop-10"
    }, null, 8, ["txt"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(waitingRoomsStore).waitingRooms, (room) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: room.roomName
        }, [
          _createElementVNode("div", _hoisted_2, [
            (room.roomBadge)
              ? (_openBlock(), _createBlock(esWaitingRoomBadge, {
                  key: 0,
                  color: room.roomBadge.color,
                  text: room.roomBadge.text,
                  class: "mright-04"
                }, null, 8, ["color", "text"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString((room.roomName && room.roomName !== "") ? room.roomName : _unref(t)('calendar.waiting.room.default')), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.occupants, (occupant) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "patient",
                key: occupant.appointmentId
              }, [
                _createVNode(EsDataCard, {
                  class: "mtop-04",
                  title: occupant.patient ? _unref(PersonService).formatHonorificAndName(occupant.patient.gender, occupant.patient?.lastname, occupant.patient?.firstname) : undefined,
                  backgroundClass:  occupant.noLinkedAtPatient ? 'bg-grey-016'  : 'bg-blue-016',
                  txtClass: "txt-primary-dark font-bold-600",
                  compact: "",
                  onClick: (e) => openPatientModal(occupant.patient, occupant.appointmentId, room, e)
                }, null, 8, ["title", "backgroundClass", "onClick"])
              ]))
            }), 128))
          ])
        ], 64))
      }), 128))
    ]),
    _createVNode(_unref(Popover), {
      ref_key: "patientPopoverRef",
      ref: patientPopoverRef,
      class: "w-550",
      dismissable: false
    }, {
      default: _withCtx(() => [
        (selectedPatient.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(PersonService).formatHonorificAndName(selectedPatient.value.gender, selectedPatient.value.lastname, selectedPatient.value.firstname)), 1),
              _createVNode(EsWaitingRoomSelector, {
                class: "w-full",
                roomName: selectedRoom.value?.roomName ?? '',
                actionLabel: "calendar.waiting.room.location.change",
                onSelectRoomEvent: _cache[0] || (_cache[0] = (location) => { updateAppointmentLocation(selectedAppointmentId.value, location) })
              }, null, 8, ["roomName"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('calendar.appointment.action.patientStatus'),
                    styles: "main-m"
                  }, null, 8, ["txt"])
                ]),
                _createVNode(_unref(SelectButton), {
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => (finishAppointment($event, selectedAppointmentId.value))),
                    _cache[2] || (_cache[2] = ($event: any) => ((currentPatientStatus).value = $event))
                  ],
                  modelValue: currentPatientStatus.value,
                  options: patientStatus.value,
                  optionLabel: "optionLabel",
                  dataKey: "optionValue",
                  size: "small",
                  class: "w-full"
                }, {
                  option: _withCtx((slotProps) => [
                    _createElementVNode("img", {
                      src: _unref(SharedService).getIcon(slotProps.option.icon, false, 'shareIcons'),
                      class: _normalizeClass(currentPatientStatus.value?.optionValue === slotProps.option.optionValue  ? 'img-white' : 'img-grey')
                    }, null, 10, _hoisted_8),
                    _createElementVNode("p", {
                      class: _normalizeClass({ 'txt-white': currentPatientStatus.value?.optionValue === slotProps.option.optionValue })
                    }, _toDisplayString(slotProps.option.optionLabel), 3)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              (currentAppointment.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('calendar.label.add.form.arrival')), 1)
                    ]),
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(formatUTCDateTimeToTime)(currentAppointment.value.arrivalTime)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_es_modal_footer, {
                  displayCancel: true,
                  "confirm-modal-method": confirmFormModal,
                  onModalCancel: confirmCancelFormModal
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})